import { useIsomorphicLayoutEffect } from "hooks/useIsomorphicLayoutEffect";
import React, { useContext } from "react";
import { CalculatorContext } from "./CalculatorContext";

import { formatPrice, formatPercentage } from "./lib/formatFunctions";

const CalculatorSummary = ({ data, carData }) => {
  const { calculatorParams } = useContext(CalculatorContext);
  useIsomorphicLayoutEffect(() => {
    const storageKey = "calculatorData";

    const mergeData = Object.assign({}, data, calculatorParams);

    localStorage.setItem(storageKey, JSON.stringify(mergeData));
  }, [data, calculatorParams]);

  return (
    <div className="pt-6 lg:px-7 px-6 pb-7 bg-gray-100 flex flex-col">
      <div className="px-4 pb-6 pt-2 mb-6 mt-0 border-b-[1px] w-auto uppercase text-center font-medium">
        <p>
          {calculatorParams.customerType === "business"
            ? "Gewerblich"
            : "Privat"}
          {""} - {""}
          {calculatorParams.type === "leasing" ? "Leasing" : "Ballonkredit"}
        </p>
      </div>

      {calculatorParams.customerType === "business" ? (
        <div className="flex lg:flex-row flex-col">
          {renderSummaryTable("Monatliche Darlehensrate:", [
            {
              label:
                calculatorParams.type === "leasing"
                  ? `Monatliche Leasingrate${
                      carData.showNettoPreis ? " (zzgl. MwSt.):" : ":"
                    }`
                  : `Monatliche Darlehensrate${
                      carData.showNettoPreis ? " (zzgl. MwSt.):" : ":"
                    }`,
              value: carData.showNettoPreis
                ? (data?.monthlyInstallment?.netValue &&
                    formatPrice(data?.monthlyInstallment?.netValue)) ||
                  formatPrice(data?.monthlyInstallmentTotalAmount?.netValue) ||
                  "No Data"
                : (data?.monthlyInstallment?.grossValue &&
                    formatPrice(data?.monthlyInstallment?.grossValue)) ||
                  formatPrice(data?.monthlyInstallmentTotalAmount?.grossValue),
            },
            {
              label: "Laufzeit",
              value: `${calculatorParams?.term || "24"} Monate`,
            },
            {
              label: "Anzahl der Raten:",
              value: calculatorParams?.term || "24",
            },
            {
              label: `${
                calculatorParams.type === "financing"
                  ? ""
                  : "Gesamtlaufleistung:"
              }`,
              value: `${
                calculatorParams.type === "financing"
                  ? ""
                  : `${calculatorParams.contractualMileage} km`
              }`,
            },
            {
              label: "Effektiver Jahreszins:",
              value: `${
                data?.effectiveInterestRate !== undefined &&
                data?.effectiveInterestRate !== null
                  ? data.effectiveInterestRate === 0
                    ? formatPercentage(0)
                    : formatPercentage(data.effectiveInterestRate)
                  : "Zinsrate"
              }`,
            },
          ])}
          {renderSummaryTable("Fahrzeugpreis", [
            {
              label: carData.showNettoPreis
                ? "Fahrzeugpreis (zzgl. MwSt.):"
                : "Fahrzeugpreis:",
              value:
                formatPrice(
                  carData.showNettoPreis ? carData?.nettoPreis : carData.preis
                ) || "purchasePrice",
            },
            {
              label: calculatorParams.type === "financing" ? "Schlussrate" : "",
              value:
                calculatorParams.type === "financing"
                  ? `${formatPrice(data?.balloon?.grossValue) || ""}`
                  : "",
            },
            {
              label:
                calculatorParams.type === "financing"
                  ? "Anzahlung"
                  : "Sonderzahlung",
              value:
                formatPrice(calculatorParams.deposit) ||
                formatPrice(data?.deposit?.netValue) ||
                "deposit",
            },
            {
              label: "Nettodarlehensbetrag:",
              value: formatPrice(data?.netLoanAmount) || "49.950,00 €",
            },
            ,
            {
              label: "Gesamtrückzahlungsbetrag:",
              value:
                (calculatorParams.type === "leasing" &&
                  typeof data?.totalRepaymentAmount === "number" &&
                  formatPrice(data?.totalRepaymentAmount)) ||
                formatPrice(data?.totalRepaymentAmount?.grossValue) ||
                "N/A",
            },
          ])}
        </div>
      ) : (
        <div className="flex lg:flex-row flex-col">
          {renderSummaryTable("Monatliche Darlehensrate:", [
            {
              label:
                calculatorParams.type === "leasing"
                  ? "Monatliche Leasingrate:"
                  : "Monatliche Darlehensrate:",
              value:
                (data?.monthlyInstallment?.grossValue &&
                  formatPrice(data?.monthlyInstallment?.grossValue)) ||
                formatPrice(data?.monthlyInstallmentTotalAmount?.grossValue) ||
                "No Data",
            },
            {
              label: "Laufzeit",
              value: `${calculatorParams?.term || "24"} Monate`,
            },
            {
              label: "Anzahl der Raten:",
              value: calculatorParams?.term || "24",
            },
            {
              label: `${
                calculatorParams.type === "financing"
                  ? ""
                  : "Gesamtlaufleistung:"
              }`,
              value: `${
                calculatorParams.type === "financing"
                  ? ""
                  : `${calculatorParams.contractualMileage} km`
              }`,
            },
            {
              label: "Effektiver Jahreszins:",
              value: `${
                data?.effectiveInterestRate !== undefined &&
                data?.effectiveInterestRate !== null
                  ? data.effectiveInterestRate === 0
                    ? formatPercentage(0)
                    : formatPercentage(data.effectiveInterestRate)
                  : "Zinsrate"
              }`,
            },
          ])}
          {renderSummaryTable("Fahrzeugpreis (inkl. MwSt.):", [
            {
              label: "Fahrzeugpreis:",
              value:
                formatPrice(calculatorParams.purchasePrice) ||
                formatPrice(data?.purchasePrice) ||
                "purchasePrice",
            },
            {
              label: calculatorParams.type === "financing" ? "Schlussrate" : "",
              value:
                calculatorParams.type === "financing"
                  ? `${formatPrice(data?.balloon?.grossValue) || ""}`
                  : "",
            },
            {
              label:
                calculatorParams.type === "financing"
                  ? "Anzahlung"
                  : "Sonderzahlung",
              value:
                formatPrice(calculatorParams.deposit) ||
                formatPrice(data?.deposit?.grossValue) ||
                "deposit",
            },
            {
              label: "Nettodarlehensbetrag:",
              value: formatPrice(data?.netLoanAmount) || "49.950,00 €",
            },

            {
              label: "Gesamtrückzahlungsbetrag:",
              value:
                (calculatorParams.type === "leasing" &&
                  typeof data?.totalRepaymentAmount === "number" &&
                  formatPrice(data?.totalRepaymentAmount)) ||
                formatPrice(data?.totalRepaymentAmount?.grossValue) ||
                "N/A",
            },
          ])}
        </div>
      )}

      <p className="text-xs font-normal mt-6">
        Dies ist eine unverbindliche beispielhafte Finanzierungskalkulation der
        ALD Lease Finanz GmbH, Fuhlsbüttler Straße 437, 22309 Hamburg, für die
        Bank Deutsches Kraftfahrzeuggewerbe GmbH als unabhängiger Vermittler
        tätig ist. Hierbei handelt es sich gleichzeitig um das repräsentative
        Beispiel gem. §17 Abs. 4 PAngV. Bonität vorausgesetzt. Alle Preise
        verstehen sich inkl. Mehrwertsteuer. Stand 14.07.2023. Irrtümer
        vorbehalten.
      </p>
    </div>
  );
};

const renderSummaryTable = (title, rows) => {
  const regex = /^\d/;

  const isNumericValue = (value) => {
    if (value === 0 || value === "0" || value === "0 %") return true;
    return regex.test(value);
  };

  return (
    <div className="relative overflow-x-auto lg:w-1/2 w-full">
      <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <tbody>
          {rows.map((row, index) => (
            <tr key={index} className={`${row.label ? "" : "hidden"}`}>
              <th
                scope="row"
                className={`${
                  index > 0 ? "pr-6" : "2xl:pr-13"
                } py-4 font-normal text-blue-dark text-sm lg:whitespace-nowrap  max-w-[35vw] lg:max-w-full`}
              >
                {row.label}
              </th>
              <td className="lg:pr-6 py-4 font-semibold md:min-w-0 min-w-[20vw]">
                {row.value && isNumericValue(row.value) ? row.value : "n.b."}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CalculatorSummary;
